export default __webpack_public_path__ + "static/media/student.0e2b99ed.svg";